import { render, staticRenderFns } from "./paymentError.vue?vue&type=template&id=acba65be&"
import script from "./paymentError.vue?vue&type=script&lang=js&"
export * from "./paymentError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports